<template>
  <div :class="['op--modal-container', {hide: !show}]" @click="close">
    <div class="op--modal">
      <div class="op--modal-content">
        <div class="more-images-box" @click.stop>
          <div class="service-label">{{moreImg.service}}</div>
          <div class="img-box">
            <i :class="['fa fa-chevron-left fa-fw fa-2x', {disabled:currentImgIndex === 0}]" @click="prev"></i>
            <transition name="fade">
              <img :src="img" :key="img" />
            </transition>
            <i :class="['fa fa-chevron-right fa-fw fa-2x', {disabled:currentImgIndex === imgs.length -1}]" @click="next"></i>
          </div>
          <div class="padding-a-m">
            <span class="op-btn btn-md btn-block" @click="close"><b>{{ $t('common.close') }}</b></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'more-images',
  data () {
    return {
      img: ''
    }
  },
  computed: {
    moreImg () { return this.$store.state.moreImages },
    show () { return this.moreImg.show },
    imgs () { return this.moreImg.imgs },
    currentImgIndex () {
      if (!this.imgs.length || !this.img) return 0
      return this.moreImg.imgs.findIndex(x => x === this.img)
    }
  },
  methods: {
    close () {
      this.$store.commit('moreImages/setImagesData', {show: false})
    },
    prev () {
      let index = this.imgs.findIndex(x => x === this.img)
      if (index < 1) return
      this.img = this.imgs[index - 1]
    },
    next () {
      let index = this.imgs.findIndex(x => x === this.img)
      if (index === -1 || index === this.imgs.length - 1) return
      this.img = this.imgs[index + 1]
    }
  },
  watch: {
    show: function (val) {
      if (val) {
        this.img = this.imgs[0]
      }
    }
  },
  mounted () {
    this.img = this.imgs[0]
  }
}
</script>

<style lang="scss" scoped>
.op--modal-container{
  overflow: auto;
  -webkit-overflow-scrolling:touch;
}

.more-images-box{
  background-color: #fff;
  max-width: 600px;
  margin: 0 auto;
  border-radius: 3px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.3);
  font-family: 'Questrial', sans-serif;
}
.service-label{
  font-size: 21px;
  font-weight: 600;
  text-align: center;
  padding: 10px;
}
.img-box{
  display:flex;
  align-items: center;
  padding-bottom: 5px;

  i{
    width: 50px;
    cursor: pointer;

    &.disabled{
      opacity: .5;
      cursor: default;
    }
  }
  img{
    width: calc(100% - 100px);
  }
}
</style>



// WEBPACK FOOTER //
// MoreImages.vue?289dc697